"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose = tslib_1.__importStar(require("mongoose"));
const pricing_quote = new mongoose.Schema({
    quote: Object,
    date_scraped: {
        type: Date,
        index: true
    }
});
const calendarDateRate = new mongoose.Schema({
    date: String,
    price: Number
});
const calendar = new mongoose.Schema({
    dateScraped: {
        type: Date,
        index: true
    },
    medianMinNights: Number,
    medianMaxNights: Number,
    availability: Number
});
const airbnbListingSchema = new mongoose.Schema({
    listing: Object,
    rates: [calendarDateRate],
    calendar: [calendar],
    pricing_quotes: [pricing_quote],
    verified: Object,
    verified_card: Boolean,
    id: {
        type: Number,
        index: true,
        unique: true
    }
}, {
    timestamps: true
});
const v1AirbnbListingModel = mongoose.model('AirbnbListing', airbnbListingSchema);
exports.v1AirbnbListingModel = v1AirbnbListingModel;
//# sourceMappingURL=AirbnbListing.model.js.map